import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Trash2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';

export const TimeEntryDeleteDialog = ({ entry, onClose, onDeleted }) => {
  const { t } = useTranslation();
  const { getAuthHeader } = useAuth();
  const [saving, setSaving] = useState(false);
  const remove = async () => {
    setSaving(true);
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/time-entries/${entry.id}`, { headers: getAuthHeader() });
      toast.success(t('timeCorrection.deleted'));
      onDeleted();
      onClose();
    } catch (error) {
      toast.error(t('timeCorrection.deleteError'));
    } finally {
      setSaving(false);
    }
  };
  return (
    <Dialog open={!!entry} onOpenChange={open => { if (!open && !saving) onClose(); }}>
      <DialogContent data-testid="delete-time-entry-dialog" className="max-w-[calc(100%-2rem)] sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t('timeCorrection.deleteTitle')}</DialogTitle>
          <DialogDescription data-testid="delete-time-entry-warning">{t('timeCorrection.deleteWarning')}</DialogDescription>
        </DialogHeader>
        {entry && <div className="text-sm break-words" data-testid="delete-time-entry-details">
          <p className="font-semibold">{entry.user_name} · {entry.date}</p>
          <p>{entry.description}</p>
          {!entry.end_time && <p className="mt-2 text-amber-700" data-testid="delete-active-timer-warning">{t('timeCorrection.deleteActiveWarning')}</p>}
        </div>}
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onClose} disabled={saving} data-testid="cancel-delete-time-entry">{t('common.cancel')}</Button>
          <Button variant="destructive" onClick={remove} disabled={saving} data-testid="confirm-delete-time-entry">
            <Trash2 className="w-4 h-4 mr-2" />{saving ? t('common.loading') : t('common.delete')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};